import React, { useRef, useEffect } from "react";

// Make sure to include in your public/index.html:
// <link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css" />
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
// <script src="https://unpkg.com/leaflet/dist/leaflet.js"></script>

const DriverTrackingMap = ({
  start,
  destination,
  driverLocation,
  completedRoute = [],
  remainingRoute = [],
  packageStatus = "Unknown",
  height = 480,
  startColor = "#071D54",
  destinationColor = "#1454F3",
}) => {
  const mapRef = useRef(null);
  const carMarkerRef = useRef(null);

  useEffect(() => {
    if (!start || !destination) return;

    const map = window.L.map(mapRef.current, { zoomControl: false, attributionControl: false })
      .setView([start.latitude, start.longitude], 10);

    window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(map);

    const packageIconUrl = "https://i.ibb.co/wrcxQt3z/newpackage.png";

    const createDivIcon = (bgColor) =>
      window.L.divIcon({
        html: `
          <div style="width:36px;height:36px;border-radius:18px;background:${bgColor};display:flex;align-items:center;justify-content:center;">
            <div style="width:30px;height:30px;border-radius:15px;background:#071D54;display:flex;align-items:center;justify-content:center;">
              <img src="${packageIconUrl}" style="width:20px;height:20px;" />
            </div>
          </div>
        `,
        className: "",
        iconSize: [36, 36],
        iconAnchor: [18, 36],
      });

    // Start & Destination markers
    window.L.marker([start.latitude, start.longitude], { icon: createDivIcon(startColor) })
      .addTo(map)
      .bindPopup(packageStatus);

    window.L.marker([destination.latitude, destination.longitude], { icon: createDivIcon(destinationColor) })
      .addTo(map)
      .bindPopup(packageStatus);

    // Driver car marker using Font Awesome icon
    if (driverLocation) {
      const carIcon = window.L.divIcon({
        html: '<i class="fa-solid fa-car" style="font-size:20px;color:white;background:#071D54;padding:6px;border-radius:50%;"></i>',
        iconSize: [30, 30],
        className: "",
      });
      carMarkerRef.current = window.L.marker([driverLocation.latitude, driverLocation.longitude], { icon: carIcon })
        .addTo(map);
    }

    const drawPolyline = (points, color = "#071D54", weight = 4) => {
      if (points.length > 0) {
        window.L.polyline(points.map(p => [p.latitude, p.longitude]), { color, weight }).addTo(map);
      }
    };

    drawPolyline(completedRoute, "#071D54", 6);
    drawPolyline(remainingRoute, "#005FFF", 6);

    // Fit map bounds
    const allPoints = [start, destination, driverLocation, ...completedRoute, ...remainingRoute]
      .filter(Boolean)
      .map(p => [p.latitude, p.longitude]);
    if (allPoints.length > 0) map.fitBounds(allPoints, { padding: [50, 50], maxZoom: 10 });

    mapRef.current._leafletMapInstance = map;

    return () => map.remove();
  }, [start, destination]);

  // Update car dynamically
  useEffect(() => {
    if (carMarkerRef.current && driverLocation) {
      carMarkerRef.current.setLatLng([driverLocation.latitude, driverLocation.longitude]);
      const map = mapRef.current?._leafletMapInstance;
      if (map) map.panTo([driverLocation.latitude, driverLocation.longitude], { animate: true });
    }
  }, [driverLocation]);

  return <div ref={mapRef} style={{ height: `${height}px`, width: "100%" }} />;
};

export default DriverTrackingMap;
